import React from 'react';
import styles from '../../assets/scss/v0/Calendar.module.scss';

const Calendar = ({ weddingDate, className }) => {
  const today = new Date();
  const currentMonth = 2; // 0-indexed, so 2 is March
  const currentYear = weddingDate.getFullYear();

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
  
  // Adjust for Monday as the first day of the week
  const adjustedFirstDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;

  const days = [];
  for (let i = 0; i < adjustedFirstDay; i++) {
    days.push(<div key={`empty-${i}`} className={styles.emptyDay}></div>);
  }

  for (let i = 1; i <= daysInMonth; i++) {
    const isToday = i === today.getDate() && today.getMonth() === currentMonth && today.getFullYear() === currentYear;
    const isWeddingDay = ((i === weddingDate.getDate()) || (i === 22))&& weddingDate.getMonth() === currentMonth;

    days.push(
      <div 
        key={i} 
        className={`${styles.day} ${isToday ? styles.today : ''} ${isWeddingDay ? styles.weddingDay : ''}`}
      >
        {i}
      </div>
    );
  }

  return (
    <div className={`${styles.calendar} ${className}`}>
      <div className={styles.header}>Tháng 03</div>
      <div className={styles.weekdays}>
        <div>T2</div><div>T3</div><div>T4</div><div>T5</div><div>T6</div><div>T7</div><div>CN</div>
      </div>
      <div className={styles.days}>
        {days}
      </div>
    </div>
  );
};

export default Calendar;